// extracted by mini-css-extract-plugin
export var quillEditor = "_mg-1";
export var variable = "_mg-0";